function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 3.28125C7.18359 3.28125 3.28125 7.18359 3.28125 12C3.28125 16.8164 7.18359 20.7188 12 20.7188C16.8164 20.7188 20.7188 16.8164 20.7188 12C20.7188 7.18359 16.8164 3.28125 12 3.28125ZM16.275 14.2887C16.4402 14.4539 16.4402 14.7211 16.275 14.8863L14.8828 16.275C14.7176 16.4402 14.4504 16.4402 14.2852 16.275L12 13.9688L9.71133 16.275C9.54609 16.4402 9.27891 16.4402 9.11367 16.275L7.725 14.8828C7.55977 14.7176 7.55977 14.4504 7.725 14.2852L10.0312 12L7.725 9.71133C7.55977 9.54609 7.55977 9.27891 7.725 9.11367L9.11719 7.72148C9.28242 7.55625 9.54961 7.55625 9.71484 7.72148L12 10.0312L14.2887 7.725C14.4539 7.55977 14.7211 7.55977 14.8863 7.725L16.2785 9.11719C16.4438 9.28242 16.4438 9.54961 16.2785 9.71484L13.9688 12L16.275 14.2887Z",
  fill: "#424240"
});

var SvgCloseWithBorder = function SvgCloseWithBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseWithBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseWithBorder.6960930a.svg";
export { ForwardRef as ReactComponent };